import React from 'react';
//import Navbar from './components/Navbar';
//import Sidebar from './components/Sidebar';
//import MainContent from './components/MainContent';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import CharterTeam from './pages/CharterTeam';
import Home from './pages/Home';
import VehicleFleet from './pages/VehicleFleet';
import RequestQuote from './pages/RequestQuote';
import ImgPage from "./pages/IMG";
import CorporatePrivateAthleticGroups from './pages/CorporatePrivateAthletic';
import Wedding from './pages/Weddings';
import SchoolGroup from './pages/SchoolGroups';
import CustomGroupTours from './pages/CustomGroupTours';



const App = () => {
  return (
    <Router>
     <Routes>
     <Route path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
     <Route path={`${process.env.PUBLIC_URL}/about-us`} element={<CharterTeam />} />
     <Route path={`${process.env.PUBLIC_URL}/vehicle-fleet`} element={<VehicleFleet />} />
     <Route path={`${process.env.PUBLIC_URL}/request-a-quote`} element={<RequestQuote />} />
     <Route path={`${process.env.PUBLIC_URL}/IMG`} element={<ImgPage/>} />
     <Route path={`${process.env.PUBLIC_URL}/corporate-private-athletic-groups`} element={<CorporatePrivateAthleticGroups/>} />
     <Route path={`${process.env.PUBLIC_URL}/wedding`} element={<Wedding/>} />
     <Route path={`${process.env.PUBLIC_URL}/school-groups`} element={<SchoolGroup/>} />
     <Route path={`${process.env.PUBLIC_URL}/custom-group-tours`} element={<CustomGroupTours/>} />
     
     {/* <Route path={`${process.env.PUBLIC_URL}/shows/:id`} element={<Show />} /> */}
   </Routes>
   </Router>
  );
};

export default App;